import React, { useState,useContext,useEffect } from 'react'
import { NavLink } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import "react-custom-flag-select/lib/react-custom-flag-select.min.css";
import './css/style.css';
import './css/login1.css';
import { unsubApi } from '../services/user-api';
import {serviceName,serviceId,Loader,service,countryCode,customStyles, getLanguages} from "../utils/constant";
import { useTranslation } from "react-i18next";
import Select from "react-select"
import { LanguageContext } from "../components/LanguageContext"

const Unsub = () => {
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState({message: "",error: false});
    const [flow, setFlow] = useState('');
    const [unsub, setUnsub] = useState(false);
    const [palyers, setPlayers] = useState('5');
    const { t } = useTranslation("global");
    const navigate = useNavigate();
    

    useEffect(() => {
            if(service==="ogb")setPlayers("10");
            if(service==="mng" || service==="mueg")setFlow("UNSUB");

    }, []);   
    const unsubFunc = async() => {
        setLoading(true);
        await unsubApi({action:2,serviceId:serviceId,mode:'WAP'}).then((res) => {
            setMessage({message:t("portalText.Unsub Msg"),error: false})
            setUnsub(true); 
            localStorage.clear(); 
        }).catch((err) => {
            console.log(err)
            setMessage({message: err.message,error: true})
        }).finally(() => setLoading(false))
       
      };
    const redirect = async(input) => {
        console.log("redirect="+service);
        if(service==="mng" || service==="mueg")window.location.href ="/home";
        else setFlow(input);
      
    }
      const { language, changeLanguage } = useContext(LanguageContext);      
      let languages = getLanguages();   
      const selectedOption = languages.find((option) => option.value === language);

       const handleChange = (selectedOption) => {
        changeLanguage(selectedOption.value)
      }

    return (
        
            <div className='home'>                 
                <div className="maine-div">
                    <div className="container-fluid box-wrapper login"> 
                    <div className='pt-5'>
                        <div className="row align-items-center">
                            <div className="col-4"></div>
                            <div className="col-4">
                                <div className="logo d-flex">
                                    {/*<img src="/images/uv_games_logo.png" alt="UVGames" />*/}
                                </div>
                            </div>

                            <div className="col-4">
                                <div className="pt-2">
                                        <Select
                                            menuPlacement="top"
                                            value={selectedOption}
                                            options={languages}
                                            onChange={handleChange}
                                            styles={customStyles}
                                            placeholder="Select Language"
                                        />        
                                </div>
                            </div>  
                        </div>
                    </div>                                    
                       
                        <div className="login-header pb-4">
                            <div className="box-wrapper mx-auto text-center position-relative"> 
                                <span className="modal-level-title game-title">
                               {service==="ogb" ?(
                                <>{t("portalText.ogbDesc")}<img className="ogMoney" src="/images/ogg.png" alt="UVGames" />{t("portalText.ogbDesc1")}</>
                                ):service==="mng"?(t("portalText.mngDesc")
                                ):service==="mtg"?(t("portalText.mtgDesc")
                                ):t("portalText.desc")
                                }
                                                  
                                </span>
                            </div>
                        </div>
                        
                        {flow==="UNSUB"?(
                            <div className="login-info">                            
                                <div className="login-thumbnail2">
                                    <img src="/images/login_img.png" alt="UVGames" />
                                </div>      
                                 <NavLink onClick={() => {redirect('')}} className="send_otp_link" > &lt;&lt;&nbsp;{t("portalText.Back")}</NavLink>
                                 
                                {message.message && <div className="mb-3"><p className={`alert alert-${message.error ? 'danger' : 'success'}`}>{message.message}</p></div>}
                                {unsub?<></>:
                                <>
                                    <h3 className="login-title mb-3 mt-3 text-center">{t("portalText.Unsub Desc")}</h3>
                            
                                    {loading ? <Loader />:
                                    <>
                                        <button className="btn btn-primary btn-pm-custom" type="button" onClick={unsubFunc}>{t("portalText.Unsub Button")}</button>
                                       
                                    </>  
                                    }  
                                </>                            
                                }
                            </div>
                        ):flow==="CONTACTUS"?(
                            <div className="login-info">
                                 <a onClick={() => {redirect('')}} className="send_otp_link"> &lt;&lt;&nbsp;{t("portalText.Back")}</a><br/><br/>
                                
                                    <p><strong><u>{t("portalText.ContactUs Header")}</u></strong></p>
                                    <div class="home-profile contact-us">
                                        <p>{t("portalText.ContactUs Desc")}.</p>
                                        <a href={"tel:+"+countryCode+"88888888888"} class="info"> <img src="/images/call.png" />{"+"+countryCode+"xxxxxxxxxx"}</a>
                                        <a href="mailto:Contact@domain.com" class="info"><img src="/images/mail.png" /> Contact@domain.com</a>                                        
                                    </div> 
                            </div>
                        ):flow==="RULES"?(
                            <div className="login-info"> 
                                <a onClick={() => {redirect('')}} className="send_otp_link" > &lt;&lt;&nbsp;{t("portalText.Back")}</a><br/><br/>
                                {language==="fr"?(<>
                                    <p><strong><u>{serviceName} - Règles et politiques</u></strong></p>
                                    <ol start="1"><li><strong>Abonnement</strong></li>
                                    <p>Le client doit s'abonner à {serviceName} via WAP/WEB{service==="ogb"?<> Or USSD #511#58#</>:(service==="ocm"?", USSD or Max it CM":"")}</p></ol>
                                    <ol start="2"><li><strong>Critères gagnants</strong></li>
                                    <p>Les abonnés qui passeront le plus de temps à jouer sur {serviceName} verront leur temps affiché sur un tableau de classement. Les {palyers} meilleurs joueurs ayant cumulé le plus d'heures de jeu seront récompensés.
                                    {service!=="mng" && "<br/>Avoir un compte Orange Money actif est dûment identifiés et à jour"}
                                    </p>
                                    </ol>
                                    <ol start="3">
                                    <li><strong>Gratifications mensuelles</strong></li> 
                                    <p>À la fin de chaque mois, Les {palyers} meilleurs joueurs ayant cumulé le plus d'heures de jeu seront récompensés. Les récompenses sont attribuées de la manière suivante :</p>
                                    {service==="ocm"?
                                        <ul>
                                        <li><strong>1ère Place : </strong>le premier abonné sur le tableau de classement reçoit 10,000 francs(Unité Orange Money)</li>
                                        <li><strong>De la 2e à la 5e place : </strong>les abonnés classés de la 2e à la 5ème place reçoivent chacun 3,000 francs(Unité de valeur Orange Money)</li>
                                        </ul>
                                    :<ul>
                                            <li><strong>1ère place:</strong> 25000F</li>
                                            <li><strong>2ème place:</strong> 10000F</li>
                                            <li><strong>3ème place:</strong> 7500F</li>
                                            <li><strong>4ème place:</strong> 5000F</li>
                                            <li><strong>5ème place:</strong> 2500F</li>

                                        </ul>
                                    }
                                    </ol>
                                </>
                                ):language==="pr"?(<>
                                    <p><strong><u>{serviceName} – Regras e Políticas</u></strong></p>
                                    <ol start="1"><li><strong>Assinatura</strong></li>
                                    <p>O cliente deverá assinar {serviceName} via WAP/WEB ou USSD #511#58#</p></ol>
                                    <ol start="2"><li><strong>Critérios de vitória</strong></li>
                                    <p>Os assinantes que passam mais tempo jogando no {serviceName} verão seu tempo exibido em uma tabela de classificação. Os {palyers} melhores jogadores que acumularem mais horas de jogo serão recompensados.
                                    <br/>Ter uma conta Orange Money ativa, devidamente identificada e atualizada
                                    </p>
                                    </ol>
                                    <ol start="3">
                                    <li><strong>Bônus mensais</strong></li> 
                                    <p>No final de cada mês, serão premiados os {palyers} melhores jogadores que acumularem mais horas de jogo. As recompensas são concedidas da seguinte forma:</p>
                                    
                                    <ul>
                                    <li><strong>1º Lugar:  </strong> o primeiro subscritor na tabela de classificação recebera 25.000 FCFA + Balur 5.000 FCFA</li>
                                    <li><strong>2º Lugar:  </strong> o segundo subscritor na tabela de classificação recebera um voucher de 20.000 FCFA</li>
                                    <li><strong>3º Lugar:  </strong> o terceiro subscritor na tabela de classificação recebera 18.000 FCFA (telefone Sanza plus)</li>
                                    <li><strong>4º Lugar:  </strong> o quarto subscritor na tabela de classificação recebera 10.000 FCFA + Balur 3.000 FCFA</li>
                                    <li><strong>5º Lugar:  </strong> o quinto subscritor na tabela de classificação recebera 23.400 FCFA</li>

                                    <li><strong>6º Lugar:  </strong> o sexto subscritor na tabela de classificação recebera 7.500 FCFA + Passe: 8 GB por 5.000 FCFA</li>
                                    <li><strong>7º Lugar:  </strong> o sétimo subscritor na tabela de classificação recebera 5.000 FCFA + Passe: 8 GB por 5.000 FCFA</li>
                                    <li><strong>8º Lugar:  </strong> o oitavo subscritor na tabela de classificação recebera 2.500 FCFA + Passe: 3,2 GB por 2.500 FCFA</li>
                                    <li><strong>9º Lugar:  </strong> o nono subscritor na tabela de classificação recebera um passe de chamadas ilimitadas por uma semana + passe internet de 3,2 GB por 2.500 FCFA</li>
                                    <li><strong>10º Lugar:  </strong> o décimo subscritor na tabela de classificação recebera um passe de chamadas ilimitadas por uma semana + passe internet semanal de 1,2 GB por 1.000 FCFA</li>

                                    </ul>
                                    </ol>
                                </>
                                ):(<>
                                    <p><strong><u>{serviceName}- Rules and Policies</u></strong></p>
                                    <ol start="1"><li><strong>Subscription</strong></li>
                                    <p>The customer must subscribe to {serviceName} via WAP/WEB {service==="ogb"?<> Or USSD #511#58#</>:(service==="ocm"?", USSD or Max it CM":"")}</p></ol>
                                    <ol start="2"><li><strong> Winning criteria</strong></li>
                                    <p>Subscribers who spend the most time playing on {serviceName} will see their time displayed on a leaderboard. The {palyers} best players who have accumulated the most hours of play will be rewarded.
                                    <br/>
                                    {service!=="mng" && "Have an active Orange Money account that is duly identified and up to date"}</p>
                                    </ol>
                                    <ol start="3">
                                    <li><strong> Monthly bonuses</strong></li> 
                                    <p>At the end of each month, the {palyers} best players who have accumulated the most hours of play will be rewarded. Rewards are awarded as follows:</p>
                                    
                                
                                    {service==="ocm"?
                                        <ul>
                                            <li><strong>1st Place:</strong> The first subscriber on the ranking table receives 10,000 francs (Orange Money Unit)</li>
                                            <li><strong>2nd to 5th Place:</strong> subscribers ranked 2nd to 5th place each receive 3,000 francs (Orange Money Value Unit)</li>
                                        </ul>
                                    :service==="ogb"?
                                        <ul>
                                            <li><strong>1st Place:</strong> The first subscriber on the ranking table receives 25.000 FCFA + Balur 5000 FCFA</li>
                                            <li><strong>2nd Place:</strong> The second subscriber on the ranking table receives 20.000 FCFA Voucher</li>
                                            <li><strong>3rd Place:</strong> The third subscriber on the ranking table receives 18.000 FCFA</li>
                                            <li><strong>4th Place:</strong> The fourth subscriber on the ranking table receives 10.000 FCFA + Balur 3.000 FCFA</li>
                                            <li><strong>5th Place:</strong> The fifth subscriber on the ranking table receives 23.400 FCFA</li>

                                            <li><strong>6th Place:</strong> The Sixth subscriber on the ranking table receives 7.500 FCFA + Pass: 8 GB for 5.000 FCFA</li>
                                            <li><strong>7th Place:</strong> The seventh subscriber on the ranking table receives 5.000 FCFA + Pass: 8 GB for 5.000 FCFA</li>
                                            <li><strong>8th Place:</strong> The Eighth subscriber on the ranking table receives 2.500 FCFA + Pass: 3.2 GB for 2.500 FCFA</li>
                                            <li><strong>9th Place:</strong> The ninth subscriber on the ranking table receives Unlimited voice pass for one week + 3.2 GB data pass for 2500 FCFA</li>
                                            <li><strong>10th Place:</strong> The tenth subscriber on the ranking table receives Unlimited voice pass for one week + 1.2 GB weekly data pass for 1000 FCFA</li>

                                        </ul>
                                    :<>
                                        <ul>
                                            <li><strong>1st Place:</strong> 25000F</li>
                                            <li><strong>2nd Place:</strong> 10000F</li>
                                            <li><strong>3rd Place:</strong> 7500F</li>
                                            <li><strong>4th Place:</strong> 5000F</li>
                                            <li><strong>5th Place:</strong> 2500F</li>

                                        </ul>
                                    </>
                                }
                                </ol>
                                </>
                            )}
                            </div>
                        ):(
                           <div className="login-info"> 
                                <div className="login-thumbnail2">
                                    <img src="/images/login_img.png" alt="UVGames" />
                                </div>    
                               <NavLink to='/' className="send_otp_link" > &lt;&lt;&nbsp;{t("portalText.Back")}</NavLink><br/>
                               <button className="btn btn-primary btn-pm-theme" type="button" onClick={() => {redirect('UNSUB')}}>{t("portalText.Unsub Button")}</button>
                               <button className="btn btn-primary btn-pm-theme" type="button" onClick={() => {redirect('RULES')}}>{t("portalText.Rules")}</button>
                               <button className="btn btn-primary btn-pm-theme" type="button" onClick={() => {redirect('CONTACTUS')}}>{t("portalText.ContactUs")}</button>
                               
                            </div>
                        )}
                        
                    </div>
                </div>
            </div>
       
    )
}

export default Unsub